import emailsStore from "@/app/emails/store/emails";

export default {
  modules: {
    emailsStore,
  },
};
